import { render, staticRenderFns } from "./ManufacturingView.vue?vue&type=template&id=a082263e&"
import script from "./ManufacturingView.vue?vue&type=script&lang=js&"
export * from "./ManufacturingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports